import React, { FC } from 'react';
import styles from './Button2.module.scss';

interface Button2Props {
  action : Function;
  children : React.ReactNode
  disabled?: boolean;
}

const Button2: FC<Button2Props> = (props) => (
  <div className={styles.Button2} data-testid="Button2">
    <button className={styles.button} disabled={props.disabled} onClick = {() => props.action()}>{props.children}</button>
  </div>
);

export default Button2;
